<template>
  <li class="product-option">
    <span v-if="!isProductCard" class="product-option__label">{{optionLabel}}</span>
    <ul class="product-option__list">
      <li class="product-option__item option-item" v-for="(item, i) in isProductCard ? visibleOptions : data.items" :key="i">
        <ProductOptionItem :item="item" />
      </li>
      <li class="product-option__more" v-if="data.items.length > 7 && isProductCard"><a :href="link">+{{data.items.length - 7}} шт.</a></li>
    </ul>
  </li>
</template>

<script>
import ProductOptionItem from '@/components/product/product-options/ProductOptionItem'

export default {
  name: 'ProductOption',
  components: {
    ProductOptionItem
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isProductCard: {
      type: Boolean,
      default: false
    },
    link: String
  },
  data () {
    return {
      visibleOptions: this.data.items.slice(0, 7)
    }
  },
  computed: {
    optionLabel () {
      if (!this.data.name) {
        return this.$t('show_more_options')
      } else {
        return this.data.name + ':'
      }
    }
  }
}
</script>

<style scoped lang="sass">

.product-option:not(:last-child)
  margin-bottom: 12px

.product-option__list
  +list-unstyled
  display: flex
  flex-flow: row wrap

.product-option__item
  margin-bottom: 8px

.product-option__item:not(:last-child)
  margin-right: 10px

.product-option__label
  display: block
  font-size: 14px
  margin-bottom: 10px
  color: $placeholder-color

.product-option__more
  background-color: $nd-border-color
  border-radius: 3px
  padding: 4px 9px
  margin-bottom: 8px
  cursor: pointer

  a
    color: $text-color
</style>
